import React, {useCallback, useEffect, useRef, useState} from 'react';
import {apiDownload, apiPost} from '../../../services/apiClient';
import {downloadFile} from '../../../services/files';
import {getCurrentUserCompanyId, getCurrentUserId, getRoles} from '../../../services/userRights';
import Forbidden from '../../forbidden/forbidden.jsx';
import {Button, Input} from "semantic-ui-react";
import FiltersAndTable from "./filtersAndTable";
import SvgNew from "../../../components/SvgNew";
import Info from "../../../components/Info";
import ConfirmModal from "../../../components/Modals/ConfirmModal";
import InformationModal from '../../../modals/infoModal';
import DocsModal from "./docsModal";
import GridHeader from "../../../components/GridHeader";
import qs from 'query-string';
import { toast } from "react-toastify";
import { costFormat } from '../../../services/cost';
import { MAX_SELECTION_COUNT } from '../../../services/utils';

const AuthorParcelsTable = ({history}) => {

    const [busyCount, setBusyCount] = useState(0);
    const [disableFilters, setDisableFilters] = useState(false);
    const [lastResponseError, setLastResponseError] = useState(null);
    const [selectedParcelIds, setSelectedParcelIds] = useState([]);
    const [summaries, setSummaries] = useState([]);
    const [settings, setSettings] = useState({});
    const [copyId, setCopyId] = useState(null);
    const [docsId, setDocsId] = useState(null);

    const infoModalRef = useRef(null);

    useEffect(() => {
        if (selectedParcelIds && selectedParcelIds.length > 0) {
            const ids = selectedParcelIds;
            apiPost('parcels/list/summary', { ids })
                .then(data => {
                    if (selectedParcelIds && selectedParcelIds.length === ids.length) {
                        setSummaries([
                            { name: 'Выбрано отправлений', value: data.count },
                            { name: 'Общая стоимость', value: `${costFormat(data.totalCost)} ₽` },
                        ]);
                    }
                })
                .catch(() => setSummaries([]));
        } else {
            setSummaries([]);
        }
    }, [selectedParcelIds]);

    const loadSelectedParcelWaybills = () => {
        let title = 'Получение накладных';
        updateBusyCount(1)
        let request = {
            ids: selectedParcelIds
        };
        apiPost('parcels/list/documents/validate', request)
            .catch(err => {
                if (err.message) {
                    infoModalRef.current.open(title, err.message);
                }
            });
        apiDownload('parcels/list/documents/zip', request)
            .then(data => {
                updateBusyCount(-1);
                if (data && data.data) {
                    downloadFile(data);
                } else {
                    infoModalRef.current.open(title, 'Ошибка при получении файла');
                }
            })
            .catch(() => updateBusyCount(-1));
    }

    // Убираем очистку при загрузке страницы - пусть работает только ограничение в 10 записей

    const updateBusyCount = (inc) => {
        setBusyCount((prevState) => {
            prevState = busyCount + inc;
            return prevState;
        });
    }

    const loadData = (settings, takeCount, skipCount, needOverlay, signal) => {
        updateBusyCount(needOverlay ? 1 : 0);
        return apiPost('parcels/list/author/all', {settings, takeCount, skipCount}, signal)
            .then(data => {
                updateBusyCount(needOverlay ? -1 : 0);
                return data;
            })
            .catch(err => {
                updateBusyCount(needOverlay ? -1 : 0);
                if (err.name === 'AbortError') {
                    // Запрос был отменен, не обрабатываем как ошибку
                    throw err;
                }
                if (err.status > 401) {
                    setLastResponseError(err.status)
                }
                throw err;
            });
    }

    const downloadExcel = () => {
        updateBusyCount(1);
        apiPost('parcels/list/author/excel', {settings})
            .then(data => {
                updateBusyCount(-1);
                let fileUrl = getApiBaseUrl() + 'files/' + data.result;
                window.location.href = fileUrl;
            })
            .catch(err => {
                updateBusyCount(-1);
            });
    }

    const handleSelectedAllChange = (newChecked) => {
        if (newChecked && !(selectedParcelIds && selectedParcelIds.length > 0)) {
            updateBusyCount(1);
            setDisableFilters(true)
            return apiPost('parcels/list/author/ids', {settings})
                .then(data => {
                    updateBusyCount(-1);
                    setDisableFilters(false);
                    if (data.ids && data.ids.length > MAX_SELECTION_COUNT) {
                        toast.warning(`Нельзя выбрать более ${MAX_SELECTION_COUNT} записей`);
                    } else {
                        setSelectedParcelIds(data.ids);
                    }
                })
                .catch(err => {
                    updateBusyCount(-1);
                    setDisableFilters(false);
                });
        } else {
            setSelectedParcelIds([]);
            setSummaries([]);
        }
    }

    const handleFiltersChange = () => {
        handleSelectedAllChange(false);
    }

    let roles = getRoles();
    let isCoordinator = roles.includes('Coordinator');
    let isAuthor = roles.includes('Author') || roles.includes('Demo') || isCoordinator;
    let companyId = getCurrentUserCompanyId();

    if (lastResponseError === 403) {
        return <Forbidden/>;
    }

    let isBusy = busyCount > 0;

    const columns = [
        {
            fieldName: 'numberAndState',
            type: 'numberAndState',
            title: 'Отправление',
            disableSort: true,
            minWidth: '230px',
            maxWidth: '230px',
        },
        {
            fieldName: 'externalNumber',
            type: 'externalNumber',
            title: 'Заказ, внешн. идент.',
            disableSort: true,
            maxWidth: '190px'
        },
        {
            fieldName: 'departureDate',
            type: 'departureDate',
            title: 'Дата отгрузки',
            disableSort: false,
            filterType: 'date',
            maxWidth: '120px'
        },
        {
            fieldName: 'deliveryDate',
            type: 'deliveryDate',
            title: 'Дата доставки',
            disableSort: false,
            filterType: 'date',
            maxWidth: '120px'
        },
        {
            fieldName: 'shipment',
            type: 'shipment',
            title: 'Отгрузка',
            disableSort: true,
        },
        {
            fieldName: 'delivery',
            type: 'delivery',
            title: 'Доставка',
            disableSort: true,
        },
        {
            fieldName: 'shipmentCompany',
            type: 'shipmentCompany',
            title: 'Перевозка',
            disableSort: true,
        },
        {
            fieldName: 'cost',
            type: 'cost',
            title: 'Финансы',
            disableSort: true,
            minWidth: '100px'
        },
        {
            fieldName: 'btns',
            type: 'btns',
            disableSort: true,
            btns: [
                (row) => <ConfirmModal
                    trigger={<Info
                        key={'createDouble'}
                        label={'Создать дубликат'}
                        position={'left'}
                        trigger={
                            <Button className='image-btn' onClick={()=>setCopyId(row.id)}>
                                <SvgNew name='createDouble'/>
                            </Button>
                        }
                        offset={[7]}
                    />}
                    label={'Копирование посылок'}
                    open={row.id === copyId}
                    setOpen={(isOpen) => setCopyId(isOpen ? row.id : null)}
                    onConfirm={() => copyParcel(row)}
                >
                    Вы действительно хотите копировать посылку?
                </ConfirmModal>,
                (row) => <DocsModal
                    trigger={<Info
                        key={'docs'}
                        label={'Документы'}
                        position={'left'}
                        trigger={
                            <Button className='image-btn' onClick={()=>setDocsId(row.id)}>
                                <SvgNew name={row.hasDocuments ? 'docs' : 'docs-inactive'} />
                            </Button>
                        }
                        offset={[7]}
                    />}
                    open={row.id === docsId}
                    setOpen={(isOpen) => setDocsId(isOpen ? row.id : null)}
                    form={row}
                />,
            ]
        },
    ];

    const copyParcel = (row) => {
        history.push(`/parcels/copy/${row.id}`);
    }

    // Инициализируем searchId из URL или localStorage
    const getInitialSearchId = () => {
        try {
            const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
            if (params.search) {
                return decodeURIComponent(params.search);
            }
            
            // Если нет в URL, загружаем из localStorage
            const userId = getCurrentUserId() || 'anonymous';
            const savedSearch = localStorage.getItem(`filtersAndTable_parcels_${userId}_search`);
            return savedSearch || '';
        } catch (e) {
            console.warn('Ошибка при загрузке searchId:', e);
            return '';
        }
    };

    const [searchId, setSearchId] = useState(getInitialSearchId());
    const [isFixed, setIsFixed] = useState(false);
    const [width, setWidth] = useState(0);

    const ro = useRef(new ResizeObserver(el => {
        setWidth(el[0].target.clientWidth);
    }));

    const resize = useCallback((container) => {
        if (container) ro.current.observe(container);
        else if (ro.current) {
            ro.current.disconnect();
            setWidth(0);
        }
    }, [ro.current]);

    const fixedScroll = (el) => {
        let scrollTop = el.scrollTop;
        setIsFixed(scrollTop > 210);
    };

    useEffect(() => {
        const el = document.getElementById('scroll-el');
        el.addEventListener('scroll', () => fixedScroll(el))
        return () => el.removeEventListener('scroll', () => fixedScroll(el))
    }, [])

    return (
        <div id='scroll-el' ref={resize} className={`new-styles new-styles__p-0 scrollable ${isFixed ? 'fixed-blocks' : ''}`}>
            <GridHeader
                width={width}
                input={<Input
                    icon='search'
                    iconPosition='left'
                    placeholder='Поиск по идентификатору'
                    value={searchId || ''}
                    onChange={(e, {value}) => setSearchId(value)}
                />}
                loading={isBusy}
                name={'Мои отправления'}
                history={history}
                canCreate={isAuthor}
                downloadExcel={downloadExcel}
                downloadWaybills={loadSelectedParcelWaybills}
                canDownloadWaybills={selectedParcelIds && selectedParcelIds.length > 0}
            />

            <FiltersAndTable
                isFixed={isFixed}
                filtersWidth={width+'px'}
                selectedIds={selectedParcelIds}
                setSelected={(id, value) => {
                    setSelectedParcelIds(ids => {
                        value ? ids = [...(ids || []), id] : ids = ids.filter(i => i !== id);
                        return ids;
                    })
                }}
                searchId={searchId}
                setSearchId={setSearchId}
                setAll={handleSelectedAllChange}
                disableFilters={disableFilters}
                onFiltersChange={() => handleFiltersChange()}
                isBusy={isBusy}
                summaries={summaries}
                loadData={(settings, take, skip, needOverlay, signal) => loadData(settings, take, skip, needOverlay, signal)}
                gridKey="parcels"
                columns={columns}
                setSettings={(settings) => setSettings(settings)}
            />

            <InformationModal ref={infoModalRef} />
        </div>
    );
}

export default AuthorParcelsTable;


// WEBPACK FOOTER //
// ./App/pages/parcels/table/authorParcelsTableNew.jsx